var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23a37.173 37.173 0 0 1-4.25-4.51C2.307 16.047 0 12.411 0 8.946-.002 5.33 2.07 2.066 5.247.681c3.178-1.385 6.835-.618 9.266 1.941C16.112 4.297 17.007 6.574 17 8.947c0 3.465-2.307 7.1-4.25 9.542A37.167 37.167 0 0 1 8.5 23Zm0-20.44c-3.352.004-6.067 2.861-6.071 6.387 0 1.49.64 4.07 3.685 7.903.75.943 1.547 1.844 2.386 2.7a35.245 35.245 0 0 0 2.387-2.696c3.044-3.84 3.684-6.418 3.684-7.907-.004-3.526-2.72-6.383-6.071-6.387Zm0 10.22c-2.012 0-3.643-1.716-3.643-3.833 0-2.116 1.631-3.832 3.643-3.832 2.012 0 3.643 1.716 3.643 3.832a3.936 3.936 0 0 1-1.067 2.71A3.554 3.554 0 0 1 8.5 12.78Z",
    fill: "#333"
  })));
};
export default SvgMap;